import { trigger } from '@angular/animations';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { ReportService } from 'src/app/services/report.service';
import { IsValidDate } from 'src/app/validation';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from '../../Auth/encrdecr.service';
declare var $: any;
@Component({
  selector: 'app-scheduleclient',
  templateUrl: './scheduleclient.component.html',
  styleUrls: ['./scheduleclient.component.scss']
})
export class ScheduleclientComponent implements OnInit {
  IsSubscribed = environment.IsSubscribed;
  IsMobile: boolean = false;
  G_UserType: any;
  //dropdownlist
  SelectedClient: any[] = [];
  selectedItems = [];
  selectedItems1 = [];
  dropdownSettings = {};

  result = [];
  resultDisplayName = [];
  ReportData: any = [];

  //added for active SIP
  ScheduleClientForm: FormGroup;
  ScheduleClientsubmitted: boolean = false;

  IsShowReport: boolean = true;
  G_SubBrokerId: any;
  OFSClient: number;
  G_LoginId: string;
  firstDay: Date;
  lastDay: Date;

  constructor(
    private reportservice: ReportService,
    private EncrdecrService: EncrdecrService,
    private fb: FormBuilder,
    private Loader: CustomLoaderService
  ) {
    this.ScheduleClientForm = this.fb.group({
      SubBrokerId: [this.G_SubBrokerId],
      ClientBasicInfoId: ['', [Validators.required]],
      FromDate: ['', [Validators.required, Validators.pattern(IsValidDate)]],
      UserType: [
        this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
      ],
      Frequency: ['', [Validators.required]],
      RdbReportType: ['true']
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  ngOnInit() {
    debugger;
    $('.MainBg').css('min-height', window.innerHeight - 112);
    this.OFSClient = parseInt(
      this.EncrdecrService.getDecr(
        sessionStorage.getItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$')
      )
    );
    this.SetViewPort(window.innerWidth);

    this.Loader.show();
    if (
      this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL')) !=
      null
    ) {
      this.G_UserType = parseInt(
        this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
      );
      this.l['UserType'].setValue(this.G_UserType);
      this.G_SubBrokerId = this.G_LoginId = this.EncrdecrService.getDecr(
        sessionStorage.getItem('F44sGAGh2xwkpUL')
      );
      this.l['SubBrokerId'].setValue(this.G_SubBrokerId);
      this.GetShceduleClient('GetAllClient');
      //to bind all clients
      this.reportservice
        .GetAllClient(this.G_UserType, this.G_SubBrokerId)
        .subscribe((data: any) => {
          this.SelectedClient = data.ArrayOfResponse;

          // if(this.G_UserType ==2 )
          // {
          //   this.selectedItems = this.SelectedClient;//added by adarsh
          // console.log('this.SelectedCliend :',this.SelectedClient)
          // this.SelectedClient.map((arr: any, index: number) => {
          //   //////
          //  //  if(arr.UCCCode != ""){
          //  //   this.firstresult.push(arr.UCCsCode);
          //  //  }
          //   this.result.push(arr.VALUEFIELD);// comment by adarsh it is used for ng muiltiselectfor by defayult all select
          //   this.resultDisplayName.push(arr.TEXTFIELD);/// comment by adarsh it is used for ng muiltiselectfor by defayult all select

          // });
          // this.resultDisplayName.push('All Investor');
          // debugger;
          // this.l['ClientBasicInfoId'].setValue(this.result.toString());
          // //console.log('this.SelectedCliend :',this.result);
          // this.Loader.hide();
          // //$('.s').selectpicker();

          // }
        });
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'VALUEFIELD',
        textField: 'TEXTFIELD',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };

      if (this.G_UserType == 2) {
        $('.DdlInv').css('display', 'block');
        sessionStorage.removeItem('UZT6qHaDZSz66kx');
      }

      let d = new Date();
      let FromDate = this.MakeSipDates(d);
      var date = new Date();
      this.firstDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1
      );
      this.lastDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 7
      );
      this.l['FromDate'].setValue(FromDate);
    }
    this.Loader.hide();
  }

  CallAlertModal(msg: any) {
    $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
    $('#AlertModalContent').text(msg);
  }

  GetShceduleClient(Flag: any) {
    let Bodydata = {
      ClientId: this.l['ClientBasicInfoId'].value,
      SubbrokerCode: this.G_SubBrokerId,
      ScheduleDate: this.l['FromDate'].value,
      Frequency: this.l['Frequency'].value,
      Flag: Flag
    };
    this.reportservice.ShceduleClient(Bodydata).subscribe((data) => {
      if (data == null || data == 'null') {
        this.ReportData = [];
      } else {
        if (data.ArrayOfResponse.length == 0) {
          this.ReportData = [];
        } else {
          let Arrayofclientresponse = [];
          Arrayofclientresponse = data.ArrayOfResponse;
          if (Flag == 'InsertUpdateClient' || Flag == 'DelteClient') {
            let msg = data.Message;
            this.CallAlertModal(msg);
          }
          this.ReportData = Arrayofclientresponse;

          $(document).ready(function () {
            debugger;
            $.fn.dataTable.ext.errMode = 'none';
            $('#ClientInfoTable').DataTable({
              oLanguage: {
                sEmptyTable: 'No Record Found.'
              },
              pageLength: 100,
              bLengthChange: false,
              bPaginate: false,
              info: false,
              searching: false,
              ordering: false,

              language: {
                paginate: {
                  next: '&#8594;', // or '→'
                  previous: '&#8592;' // or '←'
                }
              }
            });

            //======================Report tab
            $.fn.dataTable.ext.errMode = 'none';
            //Added by ROHAN
            $.extend($.fn.dataTableExt.oSort, {
              'extract-date-pre': function (value) {
                debugger;
                var date = $(value, 'span')[0].innerHTML;
                date = date.split('/');
                return Date.parse(date[1] + '/' + date[0] + '/' + date[2]); //mm/dd/yyyy
              },
              'extract-date-asc': function (a, b) {
                return a < b ? -1 : a > b ? 1 : 0;
              },
              'extract-date-desc': function (a, b) {
                return a < b ? 1 : a > b ? -1 : 0;
              }
            });
            //////
            var tables = $('#scheduleReportTable').DataTable({
              oLanguage: {
                sEmptyTable: 'No Record Found.'
              },

              columnDefs: [
                { orderable: false, targets: 'no-sort' },
                // { orderable : false, "targets": 0 }
                { type: 'extract-date', targets: [4] }
              ],
              // "order": [[0, 'asc'], [1, 'asc'], [2, ], [7, ], [9, ], [12, ], [13, ], [14, ]],
              pageLength: 50,
              bLengthChange: false,
              bFilter: true,
              language: {
                paginate: {
                  next: '&#8594;', // or '→'
                  previous: '&#8592;' // or '←'
                }
              }
            });
          });
        }
      }
      this.Loader.hide();
    });
  }

  onsubmitScheduleclient() {
    this.ScheduleClientsubmitted = true;
    if (this.ScheduleClientForm.invalid) {
      this.IsShowReport = false;
      return;
    } else {
      ////
      this.Loader.show();

      this.GetShceduleClient('InsertUpdateClient');
      this.ClearFilters();
    }
  }

  DeleteClient(ClientID: any) {
    this.l['ClientBasicInfoId'].setValue(ClientID);
    this.GetShceduleClient('DelteClient');
  }

  Active_InActivestatus(ClientID: any) {
    debugger;
    this.l['ClientBasicInfoId'].setValue(ClientID);
    this.GetShceduleClient('ClientStatus');
  }
  ngAfterViewInit() {
    $('#MainNAV .nav-item .nav-link').removeClass('active');
    $('#Id_Reports .nav-link').addClass('active');
    $('select').select2();
    $('.CustomSelect0').on('change', (e: any) => this.onChangeClient(e));
    $('.CustomSelect2').on('change', (e: any) => this.onselectFrequency(e));
    // $('.clsDatePickerFromDate')
    //   .datepicker({
    //     //orientation: "top left",
    //     autoclose: true,
    //     // endDate: this.lastDay,GDOM-275
    //     format: 'dd/mm/yyyy',
    //     // startDate: this.firstDay,
    //     todayBtn: 'linked',
    //     todayHighlight: true,
    //     orientation: 'auto bottom'
    //   })
    $('.clsDatePickerFromDate').datepicker({
      autoclose: true,
      format: 'dd/mm/yyyy',
      todayBtn: 'linked',
      todayHighlight: true,
      orientation: 'auto bottom',
      startDate: new Date(), // Disable past dates
      endDate: new Date(new Date().setDate(new Date().getDate() + 30)) // Allow only next 30 days
    })
      .on('change', (e: any) => this.SetToDateValidation(e));
  }
  MakeSipDates(d: any) {
    let month = d.getMonth() + 1;
    let day = d.getDate();
    return (
      (('' + day).length < 2 ? '0' : '') +
      day +
      '/' +
      (('' + month).length < 2 ? '0' : '') +
      month +
      '/' +
      d.getFullYear()
    );
  }
  SetToDateValidation(e: any) {
    this.l['FromDate'].setValue(e.target.value);
    // var date2 = $(".clsDatePickerFromDate").datepicker("getDate");
    // $(".clsDatePickerToDate").datepicker("setStartDate", date2);
  }

  onChangeClient(e) {
    debugger;
    if (e.target.value != '') {
      var FullName = e.target[e.target.selectedIndex].label;
      // var splitName = FullName.split("-");
      // this.PdfClientName = splitName[0];
      // this.PdfClientPAN = splitName[1];
      this.l['Frequency'].setValue(FullName);
    } else {
      this.l['Frequency'].setValue('');
    }
  }
  onItemSelect(e: any) {
    ////
    debugger;
    let amcCode = e.VALUEFIELD;
    let clientName = e.TEXTFIELD;
    // this.G_ClientName = clientName.split("-")[0].trim();
    // this.G_ClientPAN = clientName.split("-")[1].trim();
    if (amcCode) {
      let i = this.result.indexOf(amcCode);
      if (i == -1) {
        if (this.result.length > 0) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName.push(clientName);
        }
        this.result.push(amcCode);
      } else {
        this.result.splice(i, 1);
        this.resultDisplayName.splice(i, 1);
        if (this.result.length > 1) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else if (this.result.length == 1) {
          this.resultDisplayName = [];
          this.resultDisplayName.push(this.selectedItems[0].TEXTFIELD);
        } else {
          this.resultDisplayName = [];
        }
      }

      this.resultDisplayName = this.resultDisplayName;
      this.ScheduleClientForm.controls['ClientBasicInfoId'].setValue(
        this.result.toString()
      );
    }
  }

  onItemSelectDeselectAll(items: any, para: number) {
    ////
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        this.result = [];
        this.resultDisplayName = [];
        this.resultDisplayName.push('All');
        items.map((item) => {
          this.result.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.result = [];
        this.resultDisplayName = [];
        break;
    }

    this.ScheduleClientForm.controls['ClientBasicInfoId'].setValue(
      this.result.toString()
    );
  }

  onselectFrequency(event: any) {
    this.l['ClientBasicInfoId'].setValue(event.target.value);
  }
  get l() {
    return this.ScheduleClientForm.controls;
  }
  ClearFilters() {
    this.result = [];
    this.resultDisplayName = [];
    this.ScheduleClientForm.controls['ClientBasicInfoId'].setValue(
      this.result.toString()
    );
    this.selectedItems = [];
    this.ScheduleClientForm.controls['Frequency'].setValue('');
    $('.CustomSelect0').val('').trigger('change');

    $('.clsDatePickerFromDate').val(' ').datepicker('update');
    let FromDate = this.MakeSipDates(this.firstDay);
    this.l['FromDate'].setValue('');
    this.ScheduleClientForm.updateValueAndValidity(); // this will reset particular validity of formcontrol
  }
}
